import React, { useEffect, useState } from "react";
import { Box, Grid, Rating, TextField, Typography, useMediaQuery } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import { useTranslation } from "react-i18next";
import MainCard from "../components/MainCard";
import { DEFAULT_THEME, getTheme } from "../utils/theme";
import CustomerService from "../services/CustomerService";

const Survey = (props) => {
  const { setIsCompleted, style } = props;

  const isTablet = useMediaQuery(getTheme().breakpoints.down("tablet"));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [surveyComments, setSurveyComments] = useState([]);
  const [surveyAnswers, setSurveyAnswers] = useState([]);

  const { t } = useTranslation();

  const styles = {
    root: {
      padding: isTablet ? "1rem 2vw" : "1rem 10vw",
      ...style,
    },
    texts: {
      fontSize: isTablet ? "12px" : "20px",
      fontFamily: DEFAULT_THEME.typography.fontFamily,
    },
    textsCaption: {
      fontSize: "14px",
      fontFamily: DEFAULT_THEME.typography.fontFamily,
    },
    textsButton: {
      fontSize: "18px",
      fontFamily: DEFAULT_THEME.typography.fontFamilyBold,
    },
    button: {
      backgroundColor: "#000000",
      marginTop: "2rem",
      width: "300px",
      "&:hover": {
        backgroundColor: "#000000",
      },
    },
  };

  useEffect(() => {
    getQuestions();
  }, []);
  const getQuestions = async () => {
    try {
      const customerService = new CustomerService();
      let resultQuestions = await customerService.getQuestions(props.surveyId);
      setQuestions(resultQuestions);
    } catch (error) {}
  };

  const handleClick = async () => {
    if (surveyAnswers.length !== questions.length) {
      setError(true);
    } else {
      const data = {
        answers: surveyAnswers.map(function (item) {
          var comObj = surveyComments.find((c) => item.id === c.id);
          return { surveyQuestionId: item.id, answer: item.name, comment: comObj !== undefined ? comObj.comment : "" };
        }),
      };
      try {
        setLoading(true);
        const customerService = new CustomerService();
        await customerService.submitAnswer(data, props.surveyId);
      } catch (error) {
      } finally {
        setLoading(false);
        setIsCompleted(true);
      }
    }
  };

  const getSurveyAnswers = (value) => {
    var isExist = false;
    surveyAnswers.forEach((item, index) => {
      if (item.id === value.id) {
        surveyAnswers[index]["name"] = value.name;
        isExist = true;
      }
    });

    if (isExist === false) {
      setSurveyAnswers((oldArray) => [...oldArray, value]);
    }
  };

  const getComments = (value) => {
    var isExist = false;
    surveyComments.forEach((item, index) => {
      if (item.id === value.id) {
        surveyComments[index]["comment"] = value.comment;
        isExist = true;
      }
    });

    if (isExist === false) {
      setSurveyComments((oldArray) => [...oldArray, value]);
    }
  };

  return (
    <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ ...styles.root }}>
      <MainCard>
        <Grid container direction="column" justifyContent="center" alignItems="center" sx={{ pb: "1rem" }}>
          <Typography sx={{ ...styles.textsCaption }} textAlign="center" variant="caption">
            *Anketimizdeki soruları " 1 yıldız hiç memnun değilim, 5 yıldız çok memnunum" olduğunu düşünerek değerlendirmenizi rica ediyoruz.
          </Typography>
        </Grid>
        {questions.map((item, i) => {
          let question = item.question;
          return (
            <MainCard>
              <Grid container direction="column" justifyContent="center" alignItems="center">
                <Typography sx={{ ...styles.texts }}>{question}</Typography>
                <Box m={1.5} />
                <Rating
                  size="large"
                  onChange={(event, newValue) => {
                    setError(false);
                    getSurveyAnswers({ id: item.id, name: newValue });
                  }}
                />
                <Box m={1.5} />
                <TextField
                  sx={{ ...styles.texts }}
                  multiline
                  minRows={1}
                  fullWidth
                  placeholder="Görüşleriniz..."
                  inputProps={{ maxLength: 1000 }}
                  onChange={(event) => {
                    getComments({ id: item.id, comment: event.target.value });
                  }}
                />
              </Grid>
            </MainCard>
          );
        })}
        <Grid item container direction="column" justifyContent="center" alignItems="center">
          {error && (
            <Typography sx={{ ...styles.textsCaption }} color="error" variant="overline">
              Lütfen tüm soruları yanıtlayınız.
            </Typography>
          )}
          <LoadingButton sx={{ ...styles.button }} onClick={handleClick} endIcon={<SendIcon />} size="large" loading={loading} loadingPosition="end" variant="contained">
            <Typography sx={{ ...styles.textsButton }}>GÖNDER</Typography>
          </LoadingButton>
        </Grid>
      </MainCard>
    </Grid>
  );
};

export default Survey;
